import type { ApiConfig } from '@api/types';
import { typedMethodPost, typedMethodGet } from '@api/utils';
import type { DeleteToolRequestDto, StoreToolRequestDto } from '@api/generated/models';
import type { Tool, StoreToolResponse } from '@api/domain/types';
import { toTools, toStoreToolResponse } from '@api/domain/mappers';

export default ({ baseURL, baseURLoData }: ApiConfig) => ({
  get: typedMethodGet<void, Tool[]>(
    (data) =>
      fetch(`${baseURLoData}/odata/Tool`, {
        method: 'GET',
        headers: data.headers,
        signal: data.signal,
      }),
    toTools
  ),
  remove: typedMethodPost<DeleteToolRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/tool/delete`, {
        method: 'POST',
        ...data,
      })
  ),
  store: typedMethodPost<StoreToolRequestDto, StoreToolResponse>(
    (data) =>
      fetch(`${baseURL}/v1/tool/store`, {
        method: 'POST',
        ...data,
      }),
    toStoreToolResponse
  ),
});

// Re-export types for consumers
export type { Tool, StoreToolResponse } from '../../domain/types';
export type { DeleteToolRequestDto, StoreToolRequestDto } from '../../generated/models';
